import { useSyncExternalStore } from 'react';

type Toast = {
  id: string;
  kind: 'info' | 'success' | 'error';
  message: string;
  action?: { label: string; onClick: () => void };
};

let listeners: Array<() => void> = [];
let state: Toast[] = [];
function emit() { for (const l of listeners) l(); }
function subscribe(l: () => void) { listeners.push(l); return () => { listeners = listeners.filter((x) => x !== l); }; }
function snapshot() { return state; }

export const toast = {
  info: (message: string, opts?: { action?: Toast['action'] }) => push('info', message, opts),
  success: (message: string, opts?: { action?: Toast['action'] }) => push('success', message, opts),
  error: (message: string, opts?: { action?: Toast['action'] }) => push('error', message, opts),
  dismiss: (id: string) => { state = state.filter((t) => t.id !== id); emit(); },
};

function push(kind: Toast['kind'], message: string, opts?: { action?: Toast['action'] }) {
  const id = Math.random().toString(36).slice(2);
  state = [...state, { id, kind, message, action: opts?.action }];
  emit();
  setTimeout(() => toast.dismiss(id), 4000);
  return id;
}

export function ToastViewport() {
  const items = useSyncExternalStore(subscribe, snapshot, snapshot);
  return (
    <div role="region" aria-live="polite" aria-label="Notifications"
         style={{ position: 'fixed', bottom: 'var(--space-4)', left: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-2)', zIndex: 1000 }}>
      {items.map((t) => (
        <div key={t.id}
             role={t.kind === 'error' ? 'alert' : 'status'}
             style={{
               background: 'var(--color-surface)',
               border: '1px solid var(--color-border)',
               borderLeft: `4px solid ${t.kind === 'error' ? 'var(--color-danger)' : t.kind === 'success' ? 'var(--color-success, #22c55e)' : 'var(--color-fg-muted)'}`,
               padding: 'var(--space-2) var(--space-3)',
               borderRadius: 'var(--radius-2)',
               display: 'flex', gap: 'var(--space-2)', alignItems: 'center',
               minWidth: 240,
             }}
        >
          <span>{t.message}</span>
          {t.action && (
            <button onClick={() => { t.action!.onClick(); toast.dismiss(t.id); }}>
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
